(function (angular, app) {
   "use strict";
   
   // Course Handicap Controller
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.coursehandicap, CourseHandicapController);
   
   // Injector
   CourseHandicapController.$inject = ["$scope","$timeout"
     , app.modules.common.services.functions
   , app.modules.common.services.eventbus
   ];
   
   function CourseHandicapController($scope, $timeout
      , ggFunctions
      , ggCoreEventSvc) {
      
      $scope.Temp = {
         window: ggFunctions.fetchWindowSize()
      }

      var ctrl = this;
      
      // This is a string b/c of the +handicaps
      this.computed = "0";
      
      // These numbers need to come from user or app defaults
      this.handicapindex = 11.1;
      this.slope = 113;

      if (app.Member.Handicap.official && app.Member.Handicap.official.value) {
          this.handicapindex = app.Member.Handicap.official.value;
      }

      
      // Used to delay $scope.apply()
      this.isLoaded = false;
      
      // Compute Index
      this.compute = function(callback){
         
         var h, s, ch;
         
         ch = "0";
         h = Number(ctrl.handicapindex);
         s = Number(ctrl.slope);
         
         if (s == 0)
            s = 113;
            
         ch = h*(s/113);
         ch = Math.round(ch);
         
         // Negatives become Postives
         if(ch < 0){
           ch = "+" + ch.toString().substring(1,ch.length);
         }
         ctrl.computed = ch;
         if(callback){
            callback();
         }
         
      }
      
      /* 
         Why do we do this?  For some reason when we apply the scope on load, there is a JS error.  
         Probably b/c the page hasn't finished loading.  So delay the apply for the first time.
         Then allow the sliders to update the course handicap display.
      */
      $timeout(function(){
         ctrl.isLoaded = true;
         ctrl.compute(function(){
            $scope.$apply();
         });
      }, 100)
      
      // Update Hnadicap Slider
      $scope.updateHandicap = function(data){
         ctrl.handicapindex = data.value;
         ctrl.compute(function(){
            if (ctrl.isLoaded)
               $scope.$apply();
         });
      }
      // Update slope Slider
      $scope.updateSlope = function(data){
         ctrl.slope = data.value;
         ctrl.compute(function(){
            if (ctrl.isLoaded)
               $scope.$apply();
         });
      }

   }
}(angular, app));
